/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormQuestionsUpdateStatus
 */
export interface FormQuestionsUpdateStatus {
    /**
     * 
     * @type {string}
     * @memberof FormQuestionsUpdateStatus
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof FormQuestionsUpdateStatus
     */
    status: FormQuestionsUpdateStatusStatusEnum;
}

export function FormQuestionsUpdateStatusFromJSON(json: any): FormQuestionsUpdateStatus {
    return FormQuestionsUpdateStatusFromJSONTyped(json, false);
}

export function FormQuestionsUpdateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormQuestionsUpdateStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': json['category'],
        'status': json['status'],
    };
}

export function FormQuestionsUpdateStatusToJSON(value?: FormQuestionsUpdateStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'status': value.status,
    };
}

/**
* @export
* @enum {string}
*/
export enum FormQuestionsUpdateStatusStatusEnum {
    DONE = 'DONE',
    FLAGGED = 'FLAGGED',
    PENDING = 'PENDING'
}


